import * as React from 'react';
import clsx from 'clsx';
import { useOverflow } from '../../hooks';
import { Base } from '../Base';
import { useDialogContext } from './DialogContext';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "DialogContent-root_3A7eZ",
  "scrollPaper": "DialogContent-scrollPaper_2l8ov",
  "scroller": "DialogContent-scroller_36tIP",
  "scrollMarks": "DialogContent-scrollMarks_2toHB",
  "overflowTop": "DialogContent-overflowTop_3g7TC",
  "overflowBottom": "DialogContent-overflowBottom_2WS4N"
};
function DialogContent({
  children,
  className,
  ...extraProps
}) {
  const {
    scroll
  } = useDialogContext('DialogContent');
  const {
    hasOverflowTop,
    hasOverflowBottom,
    contentRef,
    scrollerRef,
    scrollerProps
  } = useOverflow();
  return /*#__PURE__*/_jsx(Base, {
    tagName: "section",
    backgroundColor: "white",
    flexAuto: true,
    grid: true,
    className: clsx(styles.root, styles.scrollMarks, {
      [styles.scrollPaper]: scroll === 'paper',
      [styles.overflowTop]: hasOverflowTop,
      [styles.overflowBottom]: hasOverflowBottom
    }, className),
    ...extraProps,
    children: /*#__PURE__*/_jsx(Base, {
      innerRef: scrollerRef,
      boxSizing: "border",
      paddingY: "base",
      paddingX: "small",
      className: styles.scroller,
      ...scrollerProps,
      children: /*#__PURE__*/_jsx("div", {
        ref: contentRef,
        children: children
      })
    })
  });
}
DialogContent.displayName = 'DialogContent';
export { DialogContent };